import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import { SAVINGS_PRESET_IMAGES_QUERY_KEY } from 'app/hooks/useFetchSavingsPresetImages';

import FileProcessingApiHandler from 'app/services/fileProcessingApiHandler';

/**
 * Deletes a savings preset cover image by file id and refreshes the preset list on success.
 */
const useDeleteSavingsPresetImage = (options?: UseMutationOptions<void, Error, string>) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (fileId: string) => FileProcessingApiHandler.deleteFile(fileId),
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: [SAVINGS_PRESET_IMAGES_QUERY_KEY] });
      options?.onSuccess?.(data, variables, context);
    },
  });
};

export default useDeleteSavingsPresetImage;
